import * as React from "react";

import { faBuilding } from "@fortawesome/free-solid-svg-icons";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import Divider from "@mui/material/Divider";
import Menu from "@mui/material/Menu";
import Router from "next/router";

import { MenuButton, MenuItem } from "src/common/components/header/Menu";
import { FontAwesomeIconWithTheme } from "src/common/components/ui/IconWrapper";
import { useDownloadEvents } from "src/domain/administrative/events/api/getEvents";

const OrgAdminDropdown: React.FC = () => {
  const download = useDownloadEvents();

  const [eventsDownloading, setEventsDownloading] = React.useState<boolean>(false);
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleRoute = (route: string) => (e: React.MouseEvent<HTMLLIElement>) => {
    e.preventDefault();

    Router.push(route);
    setAnchorEl(null);
  };

  const onResourceEventClick = async () => {
    setEventsDownloading(true);
    await download("resource", "resource_event.sql");
    setEventsDownloading(false);
  };

  return (
    <div>
      <MenuButton
        id="user-dropdown-button"
        aria-controls={open ? "composition-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        disableElevation
        onClick={handleClick}
        endIcon={<KeyboardArrowDownIcon />}
      >
        <FontAwesomeIconWithTheme icon={faBuilding} style={{ marginLeft: "5px", marginRight: "5px" }} />
        Admin
      </MenuButton>
      <Menu
        id="demo-customized-menu"
        MenuListProps={{
          "aria-labelledby": "demo-customized-button",
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
      >
        <MenuItem onClick={handleRoute(`/organization/users`)}>Users</MenuItem>
        <MenuItem onClick={handleRoute("/organization/disks")}>Disks</MenuItem>
        <MenuItem onClick={handleRoute("/organization/workflows")}>Workflows</MenuItem>
        <MenuItem onClick={handleRoute("/organization/instance-types")}>Instance Types</MenuItem>
        <Divider sx={{ my: 0.5 }} />
        <MenuItem onClick={handleRoute("/organization/accountinfo")}>Account Information</MenuItem>
        <MenuItem onClick={handleRoute("/organization/contact")}>Contact Information</MenuItem>
        <MenuItem onClick={handleRoute("/organization/workflowconfig")}>Workflow Configuration</MenuItem>
        <MenuItem onClick={handleRoute("/organization/awscredentials")}>AWS Credentials</MenuItem>
        <MenuItem onClick={handleRoute("/organization/awsnetwork")}>AWS Network</MenuItem>
        <MenuItem onClick={handleRoute("/organization/licenses")}>Licenses</MenuItem>
        <MenuItem onClick={handleRoute("/organization/workflow/blueprints")}>Blueprint Assignments</MenuItem>
        <MenuItem onClick={handleRoute("/organization/user-groups")}>User Groups</MenuItem>
        <Divider sx={{ my: 0.5 }} />
        <MenuItem onClick={onResourceEventClick} disabled={eventsDownloading}>
          Download Resource Events
        </MenuItem>
      </Menu>
    </div>
  );
};

export default OrgAdminDropdown;
